import { useTranslation } from 'react-i18next';
import {
  Button,
  GoogleFontIcon,
  PdfDocumentPreview,
} from '@asset-metrix/portal-ui';

import {
  METADATA_EXTRACTION_FROM_AI_VALUE,
  METADATA_EXTRACTION_TYPE,
} from '../constants';

import { AiExplanation } from './AiExplanation';

import styles from './filePreview.module.scss';

export type FilePreviewProps = {
  onClose?: () => void;
  fileId: string;
  fileType: string;
  fileName: string;
  previewUrl: string | null;
  extractionMethod: METADATA_EXTRACTION_TYPE;
};

export const FilePreview = ({
  fileId,
  fileName,
  fileType,
  previewUrl,
  onClose,
  extractionMethod,
}: FilePreviewProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles['root']}>
      <header className={styles['header']}>
        <h1 className={styles['header__title']}>
          {t('app.upload.documentPreview.title')}
        </h1>
        <Button
          variant="text"
          icon={<GoogleFontIcon name="close" />}
          className={styles['header__button']}
          onClick={onClose}
          data-testid="file-preview-close-button"
        />
      </header>
      <div className={styles['preview-container']}>
        <div className={styles['preview-content']}>
          {previewUrl && fileType.toLowerCase() === 'application/pdf' ? (
            <PdfDocumentPreview
              ariaLabel={t('app.pdfDocumentPreview.title')}
              filename={fileName}
              key={previewUrl}
              source={{
                type: 'url',
                url: previewUrl,
              }}
            />
          ) : (
            <p className={styles['no-preview-message']}>
              {t('app.pageSidebar.noPreviewAvailable')}
            </p>
          )}
        </div>
        {extractionMethod === METADATA_EXTRACTION_FROM_AI_VALUE && (
          <div className={styles['explanation-container']}>
            <AiExplanation fileId={fileId} />
          </div>
        )}
      </div>
    </div>
  );
};
